export const INTERESTING_FACTS: string[] = [
  // 🌍 Earth & Nature
  "Octopuses have three hearts and blue blood.",
  "Bananas are berries, but strawberries are not.",
  "There are more trees on Earth than stars in the Milky Way.",
  "Wombat poop is cube-shaped.",
  "Sharks existed before trees.",
  "A single teaspoon of honey is the lifetime work of 12 bees.",
  "The human body glows faintly, but the light is invisible to the eye.",
  "Some metals explode when dropped in water.",
  "There are more possible games of chess than atoms in the observable universe.",
  "Butterflies remember being caterpillars.",

  // 🌌 Space
  "A day on Venus is longer than a year on Venus.",
  "Neutron stars are so dense a teaspoon would weigh billions of tons.",
  "Space is completely silent.",
  "There may be rogue planets drifting through space with no star.",
  "The Moon is slowly drifting away from Earth.",
  "Saturn could float in water if a bathtub big enough existed.",
  "Mars has blue sunsets.",
  "Jupiter’s Great Red Spot is shrinking.",
  "There are likely more universes than grains of sand on Earth.",
  "Black holes can evaporate over time.",

  // 🧠 Human & Biology
  "Your brain uses about 20% of your body's total energy.",
  "Humans share about 60% of their DNA with bananas.",
  "You are taller in the morning than at night.",
  "Your nose can remember 50,000 different scents.",
  "The human eye can distinguish about 10 million colors.",
  "Your stomach lining replaces itself every few days.",
  "Humans glow under UV light.",
  "You blink about 20 times per minute.",
  "Your bones are constantly being rebuilt.",
  "Your body contains trillions of bacteria.",

  // 🕰️ History
  "Cleopatra lived closer to the Moon landing than to the building of the pyramids.",
  "The shortest war in history lasted 38 minutes.",
  "Ancient Romans used urine as detergent.",
  "Vikings used cats to control rodents on ships.",
  "The Great Wall of China is not visible from space with the naked eye.",
  "Napoleon was once attacked by rabbits.",
  "Ancient Egyptians used honey for wound treatment.",
  "There were once professional mourners at funerals.",
  "The first alarm clock could only ring at one time.",
  "Samurai carried fans as weapons.",

  // 🤖 Technology & Computing
  "The first computer bug was an actual insect.",
  "The first hard drive could store only 5MB and weighed over a ton.",
  "Email existed before the World Wide Web.",
  "More computing power fits in a smartphone than NASA had in 1969.",
  "The first webcam was used to watch a coffee pot.",
  "CAPTCHA stands for 'Completely Automated Public Turing test'.",
  "QR codes can still be read when damaged.",
  "The original PlayStation was almost a Nintendo console.",
  "Early video games inspired modern AI research.",
  "The Internet weighs about as much as a strawberry.",

  // 🎮 Gaming & Fun
  "Tetris was the first video game played in space.",
  "Pac-Man was designed to appeal to women.",
  "The most expensive video game ever made cost over $300 million.",
  "Minecraft is the best-selling game of all time.",
  "Speedrunners have beaten games in negative time using glitches.",
  "Some games contain unused content larger than the final release.",
  "NPC behavior inspired early AI research.",
  "Video game music is performed by symphony orchestras.",
  "Games are used to train surgeons and pilots.",
  "The first Easter egg in gaming was hidden in 1979.",

  // 🌀 Weird & Absurd
  "Scotland has over 400 words for snow.",
  "Cows have best friends.",
  "There is a town that banned death.",
  "Some turtles breathe through their butts.",
  "Pineapples are berries; raspberries are not.",
  "A group of flamingos is called a flamboyance.",
  "There are more possible shuffles of a deck of cards than atoms on Earth.",
  "You can smell rain.",
  "Some people can hear their eyes move.",
  "The universe may end in silence.",

  // 🧪 Science
  "Glass is technically a supercooled liquid.",
  "Hot water can freeze faster than cold water.",
  "Time moves slower near massive objects.",
  "Light has momentum.",
  "Water can boil and freeze at the same time.",
  "Atoms are mostly empty space.",
  "There are more molecules in a glass of water than glasses of water in all oceans.",
  "Quantum particles can be entangled across vast distances.",
  "Entropy always increases.",
  "Nothing can travel faster than light — except spacetime itself.",
];
